// extracted by mini-css-extract-plugin
module.exports = {"paper_shadow":"ErrorPage_paper_shadow__q1jXc"};